export default function Dashboard() {
    return (<div>Dashboard. For now you can check tickets</div>)
}